import './HeaderMob.scss';
import React from 'react';
import headerLogo from '../../assets/img/headerLogo.svg';
import { useState,useEffect} from 'react';
import { Link } from 'react-router-dom';
import burger from '../../assets/img/burger.svg';
import close from '../../assets/img/closeMob.svg';
import {langData} from './linkIconsData';
import OutsideHook from '../outsidehook/OutsideHook';
import planet from '../../assets/img/planet.svg';
import { useLocation, useMatch } from 'react-router-dom';
import { generateLanguage } from '../../i18n';
import { whitelists } from '../../i18n';

function HeaderMob(props) {
 const location = useLocation();
  const match = useMatch('/:lang/*');

  let lang = match && match.params ?
    (whitelists.includes(match.params.lang) ? match.params.lang : null) :
    null;

  const [currentLanguage, setCurrentLanguage] =  useState('RU');
  const setLanguage = (language) => {
    setCurrentLanguage(language.toUpperCase());
    props.onLanguageChange(language.toLowerCase());
    setIsShow(false)
  }

  const mobLinkItem = langData.map((item)=>(
    <Link className="language-item-mob" key={item} to={generateLanguage(item.toLocaleLowerCase(), location)}  onClick={() => {
      dropMenu();
      setLanguage(item);
 
      }}>
        <div className='mob-link-position' ><img className='language-selector-mob' src={planet} alt="planet"/>{item}</div>
    </Link>
  ))

  const defaultType =  window.location.pathname.slice(1, -1) === '' ? 'freelance': 'employers';
  const [curentType, setCurrentType] = useState(defaultType);
  const [ref ,isShow,setIsShow] = OutsideHook(false);
    const dropMenu = () => {
        setIsShow(!isShow);
      }
      useEffect(() => {
        const html = document.querySelector("html");
        if (html) {
          html.style.overflow = isShow ? "hidden" : "auto";
        }
      }, [isShow]);
    

      const freelanceLink = lang ? `/${lang}` : '/';
      const employersLink = lang ? `/${lang}/employers` : '/employers/';
      const blogLink = lang ? `/${lang}/blog`: `/blog/`    
  return (
    <div className="header-main-wrapper-mob" ref = {ref}>
      <div className="header-content">
        <div className="header-item">
          <Link className={`${"nav-link"} ${curentType === 'freelance' ? 'active': ''}`} onClick={() => setCurrentType('freelance')} to={freelanceLink} ><img src={headerLogo} alt="logo" /></Link>
        </div>
        <div className="burger-image" onClick={()=>{
            dropMenu();
            }}>
            <img src={isShow ? close : burger} alt="burger"  />
        </div>
      </div>
      <div  className={`${"drop-part-wrapper"} ${isShow? 'drop-part-wrapper-active' : ''}`}>
        {isShow &&
        <div className="header-item">
            <ul>
                <li> <Link className={`${"nav-link"} ${curentType === 'freelance' ? 'active': ''}`} onClick={() => {
                  setCurrentType('freelance'); 
                  dropMenu();
                  }} to={freelanceLink} >{props.t("header_link_freelance")}</Link> </li>
                <li> <Link className={`${"nav-link"} ${curentType === 'employers' ? 'active': ''}`} onClick={() => {
                  setCurrentType('employers'); 
                  dropMenu();
                  }} to={employersLink} >{props.t("header_link_employers")}</Link></li>
                   <li> <Link className={`${"nav-link"}  ${curentType === 'blog' ? 'active': ''}`} onClick={() => {
                    setCurrentType('blog');
                    dropMenu();
                    }} to={blogLink} >{props.t("blog_link")}</Link></li>
            </ul>
        </div>
        }
        <div className="mob-links">
            {mobLinkItem}
        </div>
        <div className='header-phone'>
        <a href="tel:+48 718 808 505" className="binct-phone-number-1">+48 718 808 505</a>
        </div>
     </div>
    </div>
  );
}

export default HeaderMob;